/* ============================================================
   story-module-sperrgebiet.js — Format „Sperrgebiet" (sg)
   Hybrid-Navigation: linearer Default-Pfad (einfach weiterscrollen)
   + Hub als Sprungkarte (Pins) + Visited-Tracking + End-Hub-Bilanz.
   Dazu: Zeitfenster-Crossfade (scroll-gescrubbte Überblendung).

   Bewusst GETRENNT vom bestehenden Hub-Modul (story-module-hub.js):
   eigener data-sg-*-Namensraum, kein data-hub/data-chapter → das alte
   Modul bleibt auf dieser Tour inert, dieses Modul auf allen anderen.
   Kein View-Gating, kein Chapter-End-Clamp — der Pfad ist linear.

   Data-Attribute:
     data-sg-hub="1"          Hub-Panel (Sprungkarte; erstes = Haupt-Hub,
                              weitere z. B. End-Hub mit Bilanz)
     data-sg-chapter="id"     Panel gehört zu Station id
     data-sg-chapter-start    Sprungziel der Station (sonst 1. Vorkommen)
     data-sg-chapter-end      letztes Panel → markiert Station als besucht
     data-sg-goto="id"        Pin/Button: springt zur Station id
     data-sg-goto-hub         Button: springt zurück zur Karte
     data-sg-reset            Button: Besucht-Status löschen + neu laden
     .sg-crossfade            Panel mit Damals↔Heute-Überblendung;
                              Höhe über --sg-cf-vh (Inline-Style), Fortschritt
                              landet als --cf (0…1) auf dem Panel. Seit AP-A
                              (sg-scrolly) generalisiert: derselbe Scrub
                              bedient auch .sg-scrolly:has(.sg-scrolly__media
                              --crossfade) — s. Abschnitt 7.

   Geteilte Infra (genutzt, nicht verändert): StoryAPI.fadeTo/goto,
   story:panel:activated (active-panel.js), Audio-Bubbles, MediaManager.
   AP-A (sg-scrolly-Szenen-Modul, eigene Datei story-module-sg-scrolly.js)
   nutzt außerdem Abschnitt 3 hier mit (data-sg-goto-hub-Bindung) und
   Abschnitt 7 (Crossfade-Scrub) — Abschnitte 1–4 unverändert.
   Self-Guard: tut nichts, wenn keine sg-Panels da sind.
   ============================================================ */
(function () {
  'use strict';

  // Self-Guard: nur auf Sperrgebiet-artigen Stories aktiv werden.
  if (!document.querySelector('[data-sg-hub], [data-sg-chapter], .sg-crossfade')) return;

  var DEBUG = window.location.search.indexOf('debug=story') !== -1;
  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[Sperrgebiet]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  var STORAGE_KEY = 'grenzwandler:sg:' + window.location.pathname;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {

    /* ───────── 1. Struktur einlesen ───────── */

    var hubPanels = Array.prototype.slice.call(document.querySelectorAll('[data-sg-hub]'));
    var chapterPanels = Array.prototype.slice.call(document.querySelectorAll('[data-sg-chapter]'));

    var chapterIds = [];
    var chapterStart = {};   // id → Panel (Sprungziel)

    chapterPanels.forEach(function (p) {
      var id = p.getAttribute('data-sg-chapter');
      if (!id) return;
      if (chapterIds.indexOf(id) === -1) chapterIds.push(id);
      if (p.hasAttribute('data-sg-chapter-start')) {
        if (chapterStart[id]) {
          console.warn('[Sperrgebiet] Doppeltes data-sg-chapter-start für Station "' + id + '"');
        } else {
          chapterStart[id] = p;
        }
      }
    });
    // Fallback: ohne expliziten Start zählt das erste Vorkommen
    chapterPanels.forEach(function (p) {
      var id = p.getAttribute('data-sg-chapter');
      if (id && !chapterStart[id]) chapterStart[id] = p;
    });

    // Spurensuche E3 (Opt-in): Neben-Kapitel mit data-sg-nocount sind
    // anspringbar (chapterStart bleibt gefüllt → goto/targetChapter), zählen
    // aber NICHT im Zähler / für „alle besucht → Abspann". Ohne Attribut
    // exakt das bisherige Verhalten (Sperrgebiet unverändert).
    var noCount = {};
    chapterPanels.forEach(function (p) {
      var id = p.getAttribute('data-sg-chapter');
      if (id && p.hasAttribute('data-sg-nocount')) noCount[id] = true;
    });
    chapterIds = chapterIds.filter(function (id) { return !noCount[id]; });

    // Konsistenz-Warnung: Pins ohne passende Station
    Array.prototype.forEach.call(document.querySelectorAll('[data-sg-goto]'), function (btn) {
      var id = btn.getAttribute('data-sg-goto');
      if (!chapterStart[id]) {
        console.warn('[Sperrgebiet] Pin data-sg-goto="' + id + '" hat keine Station.');
      }
    });

    /* ───────── 2. Besucht-Status (localStorage) ───────── */

    var visited = {};
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored) {
        var data = JSON.parse(stored);
        if (data && data.visited) visited = data.visited;
      }
    } catch (e) { /* privater Modus etc. — Tour läuft ohne Persistenz weiter */ }

    function saveState() {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ visited: visited }));
      } catch (e) { /* s. o. */ }
    }

    function allVisited() {
      return chapterIds.length > 0 && chapterIds.every(function (id) { return visited[id] === true; });
    }

    /* ───────── 3. Sprung-Navigation ───────── */

    // StoryAPI erst beim Klick auflösen (Lade-Reihenfolge der Bundles egal).
    function jumpTo(el) {
      if (!el) return;
      noteNavIntent(); // AP-B: gewollter Sprung — Hub-Halt-Fangnetz nicht auslösen
      var api = window.StoryAPI;
      var idx = (api && api.getPanels) ? api.getPanels().indexOf(el) : -1;
      if (idx !== -1 && api.fadeTo) {
        api.fadeTo(idx);
      } else if (idx !== -1 && api.goto) {
        api.goto(idx);
      } else {
        // Standalone-Fallback (Harness ohne Kern-Bundle)
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function bindOnce(btn, handler) {
      if (btn.dataset.sgBound) return;
      btn.dataset.sgBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        handler(btn);
      });
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-sg-goto]'), function (btn) {
      bindOnce(btn, function () {
        var id = btn.getAttribute('data-sg-goto');
        log('Pin: Sprung zu Station "' + id + '"');
        jumpTo(chapterStart[id]);
      });
    });

    // End-Panel (Abspann/End-Bilanz): kanonisch data-sg-hub="end",
    // zusätzlich data-sg-hub-end unterstützt (Harness-Variante).
    var endPanel = document.querySelector('[data-sg-hub="end"], [data-sg-hub-end]');
    var endReached = false; // einmal pro Seitenaufruf (wie das alte Outro)

    Array.prototype.forEach.call(document.querySelectorAll('[data-sg-goto-hub]'), function (btn) {
      bindOnce(btn, function () {
        // Abspann-Weg (David 2026-07-22): Sind alle Kapitel besucht, führt
        // der Rückweg einmalig in den Abspann statt zum Hub — §8 „Abspann
        // wird am Ende automatisch erreicht" gilt damit auch für
        // Halt-Kapitel ohne Scroll-Ausgang.
        if (allVisited() && endPanel && !endReached) {
          endReached = true;
          log('Alle Kapitel besucht → Abspann');
          jumpTo(endPanel);
          return;
        }
        log('Zurück zur Karte');
        jumpTo(hubPanels[0]);
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-sg-reset]'), function (btn) {
      bindOnce(btn, function () {
        log('Reset: Besucht-Status löschen');
        visited = {};
        saveState();
        window.location.reload();
      });
    });

    /* ───────── 4. Visited-Tracking über das aktive Panel ─────────
       Eine Quelle der Wahrheit: story:panel:activated (active-panel.js,
       ratio ≥ 0.5 bzw. Viewport-Abdeckung bei hohen Panels). Während
       fadeTo-Sprüngen ist der Observer getrennt → überflogene Panels
       werden NICHT als besucht markiert. */

    var currentChapter = null;

    document.addEventListener('story:panel:activated', function (e) {
      var panel = e.detail && e.detail.panel;
      if (!panel) return;

      // AP-B B2: Hub-Halt (Freeze/Fangnetz, Abschnitt 5c). Bei unautorisiertem
      // Hub-Übersprung ist die Aktivierung transient (es geht sofort zurück
      // zum Hub) → NICHT als besucht/aktuell werten.
      if (holdInterceptActivation(panel)) return;

      var id = panel.getAttribute ? panel.getAttribute('data-sg-chapter') : null;
      currentChapter = id || null;

      if (id && panel.hasAttribute('data-sg-chapter-end') && !visited[id]) {
        visited[id] = true;
        saveState();
        log('Station "' + id + '" besucht (' + countVisited() + '/' + chapterIds.length + ')');
      }

      updateHubUI();

      // AP-B Kapitel-Halt (Abschnitt 5d): Bereichs-Klammer für Kapitel
      // mit data-sg-chapter-hold („Rückweg nur per Link").
      updateChapterClamp(panel, id);
    });

    function countVisited() {
      return chapterIds.filter(function (id) { return visited[id]; }).length;
    }

    /* ───────── 5. Hub-/Pin-UI ───────── */

    function updateHubUI() {
      var n = countVisited();
      var total = chapterIds.length;
      var complete = allVisited();

      hubPanels.forEach(function (hub) {
        hub.setAttribute('data-sg-state', n + '/' + total);
        hub.classList.toggle('is-complete', complete);
        var counter = hub.querySelector('[data-sg-counter]');
        if (counter) counter.textContent = n + ' / ' + total;
      });

      Array.prototype.forEach.call(document.querySelectorAll('[data-sg-goto]'), function (btn) {
        var id = btn.getAttribute('data-sg-goto');
        btn.classList.toggle('is-visited', visited[id] === true);
        btn.classList.toggle('is-current', id === currentChapter);
      });

      // AP-B Marker-Brücke: Pano-Hotspots (vom Pano-Modul mit
      // data-target-chapter gestempelt) bekommen dieselben Zustände.
      Array.prototype.forEach.call(document.querySelectorAll('.pano-hotspot[data-target-chapter]'), function (hs) {
        var id = hs.getAttribute('data-target-chapter');
        hs.classList.toggle('is-visited', visited[id] === true);
        hs.classList.toggle('is-current', id === currentChapter);
      });

      document.dispatchEvent(new CustomEvent('sg:updated', {
        detail: { visited: n, total: total, complete: complete }
      }));
    }

    /* ───────── 5b. Pano-Marker-Brücke (AP-B B1) ─────────
       Das Pano-Modul stempelt data-hotspot-id + data-target-chapter auf die
       Marker-DIVs und feuert pano:hotspots:ready, sobald sie existieren
       (Viewer-Load UND LRU-Cache-Restore). Dann Zustände anwenden — die
       Marker werden bei jedem Hub-Besuch neu gebaut bzw. restauriert. */

    document.addEventListener('pano:hotspots:ready', function () {
      updateHubUI();
    });

    // Marker-Tipp = gewollter Sprung: Intent VOR dem Pannellum-Click-Handler
    // notieren (Capture läuft vor dem Target-Listener), damit das
    // Hub-Halt-Fangnetz (5c) die fadeTo-Ankunft im Kapitel nicht zurückholt.
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.pano-hotspot[data-target-chapter]')) {
        noteNavIntent();
      }
    }, true);

    /* ───────── 5c. Pano-Hub-Halt (AP-B B2) ─────────
       „Hub muss halten": der Hub darf nicht versehentlich durchscrollbar
       sein — Kapitel erreicht man nur per Marker-Tipp (David 2026-07-15).
       pano-tool-1 exportiert die Absicht als data-pano-hold="1"; die
       Durchsetzung passiert hier (sg-Kontext, self-guarded — das Pano-Modul
       bleibt generisch).

       Design (Entwurf 2026-07-21, im AP-B-Harness verifiziert):
       1) FREEZE statt Zurück-Snappen: sobald das Hub-Panel aktiv ist, wird
          der Dokument-Scroll eingefroren (body overflow:hidden — stoppt auch
          natives Touch-Momentum und versteckt die Scrollbar) + Eingabe-Schild
          (wheel/touchmove/Nav-Tasten, capture, preventDefault). KEIN
          Akkumulator, KEIN Schwellwert → kann unter beliebig vielen
          Versuchen nicht lecken (Fable F5b: das alte Zurück-Snappen des
          Gated-Hubs leckt genau daran). Pannellum-Drag/-Tasten laufen
          weiter — preventDefault stoppt nur das Dokument-Scrollen, nicht
          die Viewer-eigenen Handler.
       2) AUSRICHTEN: steht der Hub beim Einfrieren nicht bündig, wird
          programmatisch hingescrollt (geht trotz overflow:hidden; weicher
          Versuch mit hartem Fallback).
       3) FANGNETZ: aktiviert ein Scroll OHNE Nav-Intent (Marker/Button) ein
          Panel JENSEITS des Hubs (Hub in einem Satz übersprungen, z. B.
          Scrollbar-Sprung/End-Taste vor dem Freeze), geht es per fadeTo
          zurück zum Hub. Kein Zustand akkumuliert → wiederholte Versuche
          landen immer wieder im Hub.
       fadeTo (active-panel.js) kennt body-overflow bei pano-slides bereits
       (wasBlocked-Pfad) — Marker-Sprünge heben den Freeze selbst auf. */

    var holdSlide = document.querySelector('[data-sg-hub] .pano-slide[data-pano-hold="1"]');
    var holdPanel = holdSlide ? (holdSlide.closest('.story-panel') || holdSlide.closest('[data-sg-hub]')) : null;
    // Spurensuche E4 (Opt-in): derselbe Hub-Halt auch für den Flach-Pin-Hub
    // (Karte + .sg-pin) — Attribut data-sg-hub-hold="1" am Hub-Panel. Ohne
    // Pano gibt es kein Vorpuffern (Block unten bleibt an holdSlide geguardet);
    // Freeze/Ausrichten/Fangnetz laufen unverändert über holdPanel.
    if (!holdPanel) {
      holdPanel = document.querySelector('[data-sg-hub][data-sg-hub-hold="1"]');
    }

    // Pano-Vorpuffern (Sichtung 2026-07-23): Das Hub-Pano lädt sonst erst
    // bei Panel-Aktivierung — bei langsamem Medien-Server starrt man auf
    // die Ladebox. Die Intro-Lesezeit ist genau das Puffer-Fenster; der
    // Browser-Cache reicht das Bild später an Pannellum durch.
    if (holdSlide) {
      var preSrc = (window.innerWidth <= 768 && holdSlide.getAttribute('data-pano-src-mobile')) ||
        holdSlide.getAttribute('data-pano-src');
      if (preSrc) { var prefetch = new Image(); prefetch.src = preSrc; }
    }
    var holdEngaged = false;
    var holdScroller = null;          // innerer Scroll-Container oder null = Dokument
    var holdScrollerPrevOverflow = '';
    var prevActivePanel = null;
    var navIntent = false;
    var navIntentTimer = null;

    // Der reale Scroller ist im Scroll-Template der innere Container
    // (.story-container--smooth, overflow-y:auto) — nicht zwingend das
    // Dokument. Nächsten scrollbaren Vorfahren nehmen (generisch, wird von
    // Hub-Halt 5c UND Kapitel-Halt 5d genutzt).
    function findScrollerAbove(startEl) {
      var el = startEl.parentElement;
      while (el && el !== document.body) {
        var cs = window.getComputedStyle(el);
        if (/(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight + 1) {
          return el;
        }
        el = el.parentElement;
      }
      return null; // Dokument-Scroller
    }

    function findHoldScroller() { return findScrollerAbove(holdPanel); }

    // Programmatisch scrollen — funktioniert auch unter overflow:hidden
    // (hidden ≠ clip: die Box bleibt Scroll-Container).
    function scrollByOn(scroller, delta, smooth) {
      if (scroller) {
        if (smooth) {
          try { scroller.scrollTo({ top: scroller.scrollTop + delta, behavior: 'smooth' }); return; }
          catch (err) { /* fällt durch */ }
        }
        scroller.scrollTop += delta;
      } else {
        var y = (window.pageYOffset || document.documentElement.scrollTop || 0) + delta;
        if (smooth) {
          try { window.scrollTo({ top: y, behavior: 'smooth' }); return; }
          catch (err2) { /* fällt durch */ }
        }
        window.scrollTo(0, y);
      }
    }

    function noteNavIntent() {
      if (!holdPanel) return;
      navIntent = true;
      clearTimeout(navIntentTimer);
      navIntentTimer = setTimeout(function () { navIntent = false; }, 4000);
    }

    var HOLD_NAV_KEYS = [' ', 'Spacebar', 'PageDown', 'PageUp', 'ArrowDown', 'ArrowUp', 'Home', 'End'];

    function shieldWheel(e) { e.preventDefault(); }
    function shieldTouch(e) {
      // Scrollbare Overlays (Info-Tooltip) weiter bedienbar lassen
      if (e.target && e.target.closest && e.target.closest('.pano-info-tooltip')) return;
      e.preventDefault();
    }
    function shieldKeys(e) {
      if (HOLD_NAV_KEYS.indexOf(e.key) === -1) return;
      var t = e.target;
      if (t && /^(INPUT|TEXTAREA|SELECT|BUTTON)$/.test(t.tagName)) return;
      e.preventDefault();
    }

    // Abweichung des Hub-Panels von der Scroller-Oberkante (px)
    function holdOffset() {
      var top = holdPanel.getBoundingClientRect().top;
      var refTop = holdScroller ? holdScroller.getBoundingClientRect().top : 0;
      return top - refTop;
    }

    function holdScrollBy(delta, smooth) {
      scrollByOn(holdScroller, delta, smooth);
    }

    function alignToHold() {
      var delta = holdOffset();
      if (Math.abs(delta) <= 2) return;
      holdScrollBy(delta, true);
      // Fallback: greift der Smooth-Scroll unter overflow:hidden nicht
      // (browserabhängig), hart ausrichten. WICHTIG: navIntent prüfen —
      // sonst macht der nachlaufende Timer einen Marker-Sprung rückgängig,
      // der ins Ausricht-Fenster fällt (Race: Einrasten → sofort tippen).
      setTimeout(function () {
        if (!holdEngaged || navIntent) return;
        var rest = holdOffset();
        if (Math.abs(rest) > 2) holdScrollBy(rest, false);
      }, 700);
    }

    /* Ratschen-Klammer: echte Gesten sind im Browser „gelatcht" — eine beim
       Einfrieren bereits laufende Scroll-Geste liefert nicht-abbrechbare
       Events (cancelable:false) und bewegt den Scroller TROTZ overflow:hidden
       und preventDefault weiter (Davids QA-Fund, Schritt 2). Deshalb wird
       während des Halts jedes Scroll-Ereignis geprüft: Bewegung ZUM Hub hin
       ist erlaubt (Ratsche zieht nach — die Einfahrt gleitet natürlich aus),
       jede Bewegung WEG vom Hub wird sofort hart zurückgesetzt. */
    var holdRatchet = 0;

    function onHoldScroll() {
      if (!holdEngaged || navIntent) return;
      var off = holdOffset();
      var abs = Math.abs(off);
      if (abs <= holdRatchet + 2) {
        if (abs < holdRatchet) holdRatchet = abs;
        return;
      }
      holdScrollBy(off - (off > 0 ? 1 : -1) * holdRatchet, false);
    }

    function engageHold() {
      if (holdEngaged) return;
      holdEngaged = true;
      holdScroller = findHoldScroller();
      if (holdScroller) {
        holdScrollerPrevOverflow = holdScroller.style.overflowY;
        holdScroller.style.overflowY = 'hidden';
      }
      // body zusätzlich einfrieren: deckt Dokument-Scroller-Layouts ab und
      // ist der Haken, den fadeTo (wasBlocked-Pfad) bereits kennt.
      document.body.style.overflow = 'hidden';
      document.addEventListener('wheel', shieldWheel, { passive: false, capture: true });
      document.addEventListener('touchmove', shieldTouch, { passive: false, capture: true });
      document.addEventListener('keydown', shieldKeys, true);
      holdRatchet = Math.abs(holdOffset());
      // scroll bubblet nicht — Capture auf window fängt auch Container-Scroll
      window.addEventListener('scroll', onHoldScroll, { passive: true, capture: true });
      alignToHold();
      log('Hub-Halt: eingefroren', holdScroller ? '(Container-Scroller)' : '(Dokument-Scroller)');
    }

    function disengageHold() {
      if (!holdEngaged) return;
      holdEngaged = false;
      if (holdScroller) {
        holdScroller.style.overflowY = holdScrollerPrevOverflow;
        holdScroller = null;
      }
      document.body.style.overflow = '';
      document.removeEventListener('wheel', shieldWheel, { capture: true });
      document.removeEventListener('touchmove', shieldTouch, { capture: true });
      document.removeEventListener('keydown', shieldKeys, true);
      window.removeEventListener('scroll', onHoldScroll, { capture: true });
      log('Hub-Halt: gelöst');
    }

    // -1 = vor dem Hub (Intro-Seite) · 0 = Hub selbst · +1 = hinter dem Hub
    function sideOfHold(p) {
      if (p === holdPanel) return 0;
      var pos = holdPanel.compareDocumentPosition(p);
      return (pos & Node.DOCUMENT_POSITION_PRECEDING) ? -1 : 1;
    }

    // true = Aktivierung war unautorisiert (transient, nicht als besucht/
    // aktuell werten — es geht sofort zurück zum Hub). Regeln (David-QA
    // 2026-07-22, Hub-and-Spoke strikt):
    //   - Hub-Kreuzung per Scroll → abfangen (wie gehabt).
    //   - Jenseits des Hubs ist nur Scrollen INNERHALB desselben Kapitels
    //     frei; Kapitel→Kapitel ohne Marker → abfangen (sonst wird das
    //     Folgekapitel fälschlich „besucht", Zähler 2/4 statt 1/4).
    //   - Nicht-Kapitel-Panels jenseits des Hubs (Abspann) sind erst bei
    //     „alle besucht" per Scroll erreichbar (§8: automatisch am Ende).
    //   - Vor dem Hub (Intro-Bereich) bleibt alles frei.
    // Beim Abfangen wird NICHT entfroren — das Freigabe-Fenster der alten
    // Fassung war das Leck der Oszillation (Davids QA, Schritt 2).
    var holdReturning = false;

    function holdInterceptActivation(panel) {
      if (!holdPanel) return false;

      if (panel === holdPanel) {
        engageHold();
        navIntent = false; // Ankunft verbraucht den Intent
        holdReturning = false;
        prevActivePanel = panel;
        return false;
      }

      // Rückholung läuft bereits → Zwischenaktivierungen ignorieren
      if (holdReturning) {
        prevActivePanel = panel;
        return true;
      }

      var legit = navIntent;
      if (!legit && prevActivePanel && prevActivePanel !== panel) {
        var a = sideOfHold(prevActivePanel);
        var b = sideOfHold(panel);
        if ((a <= 0 && b > 0) || (a >= 0 && b < 0)) {
          legit = false; // Hub-Kreuzung
        } else if (b > 0) {
          var chapterPrev = prevActivePanel.getAttribute('data-sg-chapter');
          var chapterNew = panel.getAttribute('data-sg-chapter');
          if (chapterNew && chapterPrev === chapterNew) {
            legit = true;                    // Block-Wechsel im selben Kapitel
          } else if (!chapterNew) {
            legit = allVisited();            // Abspann erst wenn komplett
          } else {
            legit = false;                   // Kapitel→Kapitel ohne Marker
          }
        } else {
          legit = true;                      // Intro-Seite frei
        }
      } else if (!legit) {
        legit = true;                        // Erst-Aktivierung / gleiches Panel
      }

      var leavingChapter = prevActivePanel ? prevActivePanel.getAttribute('data-sg-chapter') : null;
      var forward = prevActivePanel && prevActivePanel !== panel &&
        !!(prevActivePanel.compareDocumentPosition(panel) & Node.DOCUMENT_POSITION_FOLLOWING);

      prevActivePanel = panel;
      if (legit) {
        disengageHold();
        navIntent = false;
        return false;
      }

      // Kapitel-Abschluss-Gutschrift: Wer sein Kapitel nach VORN verlässt,
      // hat dessen -end-Panel passiert (Blöcke sind zusammenhängend, s.
      // Export-Kommentar) — auch wenn der Observer das -end-Panel beim
      // schnellen Scrollen übersprungen hat. Rückwärts-Verlassen zählt nicht.
      if (leavingChapter && forward && !visited[leavingChapter]) {
        visited[leavingChapter] = true;
        saveState();
        log('Station "' + leavingChapter + '" besucht (vorwärts verlassen, ' +
          countVisited() + '/' + chapterIds.length + ')');
      }

      log('Hub-Halt: unautorisierte Aktivierung (' + (panel.className || '') + ') → zurück zum Hub');
      holdReturning = true;
      setTimeout(function () { holdReturning = false; }, 3000); // Failsafe
      jumpTo(holdPanel);
      return true;
    }

    /* ───────── 5d. Kapitel-Halt (Bereichs-Klammer, David 2026-07-22;
       Freeze-Umbau 2026-07-25) ─────────
       Kapitel mit data-sg-chapter-hold (am -start-Panel; Tool-Option
       „Rückweg nur per Link"): Solange ein Panel dieses Kapitels aktiv ist,
       bleibt der Scroll auf den Kapitel-Bereich begrenzt (Oberkante erster
       Block … Unterkante letzter Block). INNERHALB (mehrere Blöcke, hohe
       Szene, Galerie) scrollt alles frei — an den Rändern steht man an, in
       beide Richtungen. Einziger Ausgang: der Home-Link (fadeTo, navIntent).

       Warum FREEZE statt Per-Event-Rückholung (Galerie-Flimmern, gemessen
       2026-07-25): Das alte onClampScroll holte pro Scroll-Ereignis hart auf
       die Grenze zurück. Trackpad-/Touch-Momentum liefert aber non-cancelable
       Events (das Wheel-Schild ist dann wirkungslos) und scrollt auf dem
       Compositor-Thread weiter — der paintet den Overshoot, BEVOR die
       Main-Thread-Korrektur greift → 1-Frame-Versatz pro Zyklus = sichtbares
       Wackeln der Galerie. Fix wie beim Hub-Halt (5c): an der Auswärts-Kante
       den Scroller kurz nicht-scrollbar machen (overflow:hidden killt die
       Trägheit an der Quelle), Freigabe bei Einwärts-Geste / kurzem Settle /
       navIntent. Cancelable Events (Mausrad, Tasten) fängt weiterhin das
       Wheel-Schild sauber ab — dort braucht es keinen Freeze. Kapitel ohne
       das Attribut verhalten sich exakt wie bisher (Rückholung 5c). */

    var clampChapterId = null;
    var clampPanels = [];
    var clampScroller = null;
    var CLAMP_SETTLE_MS = 280;        // Ruhefenster nach dem letzten Auswärts-Stoß
    var clampFrozen = false;
    var clampFrozenEdge = null;       // 'top' | 'bottom'
    var clampScrollerPrevOverflow = '';
    var clampBodyPrevOverflow = '';
    var clampSettleTimer = null;

    function clampBounds() {
      var refTop = clampScroller ? clampScroller.getBoundingClientRect().top : 0;
      var vh = clampScroller ? clampScroller.clientHeight : window.innerHeight;
      var first = clampPanels[0].getBoundingClientRect();
      var last = clampPanels[clampPanels.length - 1].getBoundingClientRect();
      return {
        overTop: first.top - refTop,          // > 0: über den Anfang hinaus (nach oben)
        underBottom: (last.bottom - refTop) - vh  // < 0: übers Ende hinaus (nach unten)
      };
    }

    function scheduleClampSettle() {
      clearTimeout(clampSettleTimer);
      clampSettleTimer = setTimeout(releaseClampFreeze, CLAMP_SETTLE_MS);
    }

    // Auswärts-Kante einfrieren: Scroller nicht-scrollbar machen → der
    // Compositor kann die laufende Trägheit nicht weiterscrollen (wie 5c
    // engageHold). Programmatisches Ausrichten bleibt möglich (hidden ≠ clip).
    function engageClampFreeze(edge) {
      clampFrozenEdge = edge;
      if (!clampFrozen) {
        clampFrozen = true;
        if (clampScroller) {
          clampScrollerPrevOverflow = clampScroller.style.overflowY;
          clampScroller.style.overflowY = 'hidden';
        } else {
          clampBodyPrevOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }
        log('Kapitel-Halt: Kante eingefroren (' + edge + ')');
      }
      scheduleClampSettle();
    }

    function releaseClampFreeze() {
      clearTimeout(clampSettleTimer);
      if (!clampFrozen) return;
      clampFrozen = false;
      clampFrozenEdge = null;
      if (clampScroller) {
        clampScroller.style.overflowY = clampScrollerPrevOverflow;
      } else {
        document.body.style.overflow = clampBodyPrevOverflow;
      }
      log('Kapitel-Halt: Kante freigegeben');
    }

    function onClampScroll() {
      if (!clampPanels.length || navIntent) { releaseClampFreeze(); return; }
      var b = clampBounds();
      if (b.overTop > 2) {
        scrollByOn(clampScroller, b.overTop, false);   // einmal exakt an die Grenze
        engageClampFreeze('top');
      } else if (b.underBottom < -2) {
        scrollByOn(clampScroller, b.underBottom, false);
        engageClampFreeze('bottom');
      }
    }

    function onClampWheel(e) {
      if (!clampPanels.length || navIntent) return;
      if (clampFrozen) {
        // Einwärts (zurück ins Kapitel) → Freeze lösen und die Geste
        // durchlassen; Auswärts → Wand hält, Freeze offen halten.
        var inward = (clampFrozenEdge === 'bottom' && e.deltaY < 0) ||
                     (clampFrozenEdge === 'top' && e.deltaY > 0);
        if (inward) { releaseClampFreeze(); return; }
        e.preventDefault();
        scheduleClampSettle();
        return;
      }
      var b = clampBounds();
      // an der Kante in Auswärts-Richtung: cancelable Geste gar nicht wirken lassen
      if ((e.deltaY < 0 && b.overTop > -2) || (e.deltaY > 0 && b.underBottom < 2)) {
        e.preventDefault();
      }
    }

    // Mobil: eine neue Berührung ist eine neue gewollte Geste → Freeze lösen,
    // damit das Zurückscrollen sofort greift (das Momentum davor ist beendet).
    function onClampTouchStart() {
      if (clampFrozen) releaseClampFreeze();
    }

    function engageChapterClamp(id) {
      if (clampChapterId === id) return;
      disengageChapterClamp();
      clampChapterId = id;
      clampPanels = chapterPanels.filter(function (p) {
        return p.getAttribute('data-sg-chapter') === id;
      });
      if (!clampPanels.length) { clampChapterId = null; return; }
      clampScroller = findScrollerAbove(clampPanels[0]);
      window.addEventListener('scroll', onClampScroll, { passive: true, capture: true });
      document.addEventListener('wheel', onClampWheel, { passive: false, capture: true });
      document.addEventListener('touchstart', onClampTouchStart, { passive: true, capture: true });
      log('Kapitel-Halt aktiv (nur Link zurück): Kapitel', id);
    }

    function disengageChapterClamp() {
      if (!clampChapterId) return;
      releaseClampFreeze();            // vor dem Nullen des Scrollers entfrosten
      clampChapterId = null;
      clampPanels = [];
      clampScroller = null;
      window.removeEventListener('scroll', onClampScroll, { capture: true });
      document.removeEventListener('wheel', onClampWheel, { capture: true });
      document.removeEventListener('touchstart', onClampTouchStart, { capture: true });
      log('Kapitel-Halt gelöst');
    }

    function updateChapterClamp(panel, chapterId) {
      if (chapterId && chapterStart[chapterId] &&
          chapterStart[chapterId].hasAttribute('data-sg-chapter-hold')) {
        engageChapterClamp(chapterId);
      } else {
        disengageChapterClamp();
      }
    }

    /* ───────── 6. Pin-Ebene auf Contain-Geometrie des Luftbilds ─────────
       Pins (--x/--y in %) sollen auf dem BILDINHALT sitzen, nicht auf dem
       Panel. Die Pin-Ebene wird deshalb auf die contain-Fläche des
       .sg-hub__bg-Bildes gelegt (Muster aus story-module-hub.js). Fehlt
       Bild oder Ebene, bleiben die Pins einfach panel-relativ. */

    function resizePinLayer(panel, img, layer) {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var pw = panel.clientWidth, ph = panel.clientHeight;
      var ir = img.naturalWidth / img.naturalHeight;
      var pr = pw / ph;
      var w, h;
      if (ir > pr) { w = pw; h = pw / ir; } else { h = ph; w = ph * ir; }
      layer.style.width = w + 'px';
      layer.style.height = h + 'px';
      layer.style.left = ((pw - w) / 2) + 'px';
      layer.style.top = ((ph - h) / 2) + 'px';
    }

    hubPanels.forEach(function (hub) {
      var img = hub.querySelector('.sg-hub__bg');
      var layer = hub.querySelector('.sg-hub__pins');
      if (!img || !layer) return;

      var apply = function () { resizePinLayer(hub, img, layer); };
      if (img.complete && img.naturalWidth) { apply(); }
      img.addEventListener('load', apply);

      if (window.ResizeObserver) {
        new ResizeObserver(apply).observe(hub);
      } else {
        var timer;
        window.addEventListener('resize', function () {
          clearTimeout(timer);
          timer = setTimeout(apply, 100);
        });
      }
    });

    /* ───────── 7. Zeitfenster-Crossfade ─────────
       Panel .sg-crossfade ist höher als der Viewport (--sg-cf-vh); die
       innere Bühne klebt (position:sticky). Der Scroll-Fortschritt durch
       das Panel wird als --cf (0…1) gesetzt — CSS blendet damit die
       „Damals"-Ebene ein. Scroll-Listener mit Capture: fängt sowohl
       Document-Scroll (Scroll-Template) als auch Container-Scroll
       (Snap-Template, .story-container--snap).

       Generalisiert (AP-A, implementation-sperrgebiet.html V1): dieselbe
       Scrub-Logik bedient jetzt AUCH den optionalen BG-Bild-Crossfade
       innerhalb einer sg-scrolly-Szene (FORMAT-REFERENZ.html §4,
       .sg-scrolly__media--crossfade). --cf wird dafür auf die ganze
       .sg-scrolly-Szene gesetzt (deren Höhe = --sg-scene-vh) und erbt zu
       .sg-scrolly__cf-layer--after herunter — kein separater JS-Code in
       story-module-sg-scrolly.js nötig. */

    var cfPanels = Array.prototype.slice.call(document.querySelectorAll(
      '.sg-crossfade, .sg-scrolly:has(.sg-scrolly__media--crossfade)'
    ));
    if (cfPanels.length) {
      var ticking = false;

      var updateCf = function () {
        ticking = false;
        var vh = window.innerHeight;
        cfPanels.forEach(function (p) {
          var rect = p.getBoundingClientRect();
          var span = rect.height - vh; // scrollbare Strecke innerhalb des Panels
          var progress;
          if (span <= 0) {
            progress = rect.top < vh / 2 ? 1 : 0;
          } else {
            progress = Math.min(1, Math.max(0, -rect.top / span));
          }
          p.style.setProperty('--cf', progress.toFixed(4));
        });
      };

      var onScroll = function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateCf);
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onScroll);
      updateCf();
    }

    /* ───────── 8. Init-Abschluss ───────── */

    updateHubUI();

    // Test-Haken für Playwright (?__test__)
    if (window.location.search.indexOf('__test__') !== -1) {
      window.__sgTest__ = {
        chapterIds: chapterIds,
        chapterStart: chapterStart,
        hubPanels: hubPanels,
        getVisited: function () { return visited; },
        getCurrent: function () { return currentChapter; },
        allVisited: allVisited,
        // AP-B: Hub-Halt-Introspektion
        holdPanel: holdPanel,
        isHoldEngaged: function () { return holdEngaged; },
        hasNavIntent: function () { return navIntent; },
        // AP-B Kapitel-Halt (5d)
        getClampedChapter: function () { return clampChapterId; },
        isClampFrozen: function () { return clampFrozen; }
      };
    }

    log('Initialisiert:', {
      stationen: chapterIds,
      hubs: hubPanels.length,
      crossfades: cfPanels.length,
      besucht: visited
    });
  });

})();
